<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2" v-text="Title"></h5>
                  </b-col>
                  <b-col lg="3" md="3" class="p-0">
                    <b-input-group>
                      <b-input-group-text slot="prepend" class="search-icon">
                        <font-awesome-icon :icon="['fas', 'search']" />
                      </b-input-group-text>
                      <b-form-input
                        v-model="search"
                        placeholder="Search customers (Press enter to search)"
                        @keyup.enter="seachFunction"
                        @keyup.delete="clearSearch"
                        class="search"
                        id="cust-search"
                        autocomplete="off"
                        v-shortkey.focus="['ctrl', 's']"
                        autofocus
                        :disabled="$loading"
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" md="2" class="pl-1">
                    <b-button
                      block
                      variant="primary"
                      v-on:click="isContentShow = !isContentShow"
                      disabled
                      id="view-filter"
                      >View Filter</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section v-if="!$loading && customerInfo == ''">
        <b-container fluid>
          <b-row class>
            <b-col
              md="12"
              class="d-flex align-items-center justify-content-center"
              style="height: 90vh;"
            >
              <p class="text-muted">No customers found.</p>
            </b-col>
          </b-row>
        </b-container>
      </section>

      <section v-if="customerInfo != ''">
        <b-container fluid>
          <div class="card mt-2">
            <div class="customer-info box-shadow">
              <b-container fluid>
                <b-row class="py-1 px-2 activites-bar">
                  <b-col md="3">Name of Customer</b-col>
                  <b-col md="2">Phone</b-col>
                  <b-col md="2">Location</b-col>
                  <b-col md="1">Total Spent</b-col>
                  <b-col md="1">Total Bills</b-col>
                  <b-col md="1">Loyalty</b-col>
                  <b-col md="1">Store Credit</b-col>
                  <b-col md="1">Balance</b-col>
                </b-row>
                <div class="customer-data">
                  <b-row
                    class="py-3 px-4 align-items-center"
                    v-for="info in customerInfo"
                    :key="info.id"
                    @click="getCustomerDetails(info.mobile)"
                  >
                    <b-col md="3">
                      <h6 class="font-normal mb-0 d-flex align-items-center">
                        <span
                          v-text="info.first_name + ' ' + info.last_name"
                        ></span>
                        <b-badge
                          v-for="tag in info.groups"
                          :key="tag.id"
                          class="font-normal ml-2 px-2 py-2"
                          v-text="tag"
                        ></b-badge>
                      </h6>
                    </b-col>
                    <b-col md="2"><span v-text="info.mobile"/></b-col>
                    <b-col md="2"><span v-text="info.location"/></b-col>
                    <b-col md="1"><span v-text="info.spent"/></b-col>
                    <b-col md="1"><span v-text="info.bills"/></b-col>
                    <b-col
                      md="1"
                      :class="[info.loyalty == '0.00' ? 'light-grey' : null]"
                      ><span v-text="info.loyalty"
                    /></b-col>
                    <b-col
                      md="1"
                      :class="[
                        info.store_credit_amount == '0.00'
                          ? 'light-grey'
                          : null,
                      ]"
                      ><span v-text="info.store_credit_amount"
                    /></b-col>
                    <b-col
                      md="1"
                      :class="[
                        info.account < '0.00' ? 'text-danger' : 'light-grey',
                      ]"
                      ><span v-text="info.account"
                    /></b-col>
                  </b-row>
                </div>
              </b-container>
            </div>

            <div class="clearfix"></div>
          </div>
          <div
            class="mt-2 d-flex px-2 justify-content-between w-100 align-items-center"
          >
            <div
              v-text="
                `Showing ${customerInfo.length} out of ${paginationData.total_records} entries`
              "
            ></div>
            <b-pagination
              class="mb-0"
              v-model="page"
              :total-rows="paginationData.total_records"
              :per-page="paginationData.per_page"
              :number-of-pages="paginationData.total_records"
              :limit="3"
              last-number
              @change="pageNumber"
              align="right"
            />
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "customers",
  components: {
    Dashboard,
    Loading,
  },
  mounted() {
    this.fetchCustomerList();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },

  data() {
    return {
      Title: "Customers",
      loading: true,
      search: "",
      remarks: "",
      isHidden: false,
      customerInfo: [],
      page: 1,
      paginationData: {
        total_records: 0,
        per_page: 0,
      },
    };
  },
  methods: {
    seachFunction() {
      this.page = 1;
      this.fetchCustomerList();
    },
    clearSearch() {
      if (this.search == "") {
        this.page = 1;
        this.fetchCustomerList();
      }
    },
    getCustomerDetails(mobile) {
      if (
        this.state.billing.billing.customer.data != "" &&
        this.state.billing.billing.customer.data.mobile == mobile
      ) {
        let alertData = {
          message: "Untag customer before continuing",
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      } else {
        this.$router.push("/customer-list/" + mobile);
      }
    },
    contentShow(content) {
      this.isContentShow = content;
    },
    fetchCustomerList() {
      this.$loading = true;
      let data = {
        url: "/customer/list",
        v_id: this.state.sessions.user.v_id,
        api_token: this.state.sessions.user.api_token,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        search: this.search,
        page: this.page,
      };

      axios
        .post(data.url, data)
        .then((res) => {
          this.paginationData = {
            total_records: res.data.listing.total,
            per_page: res.data.listing.per_page,
          };
          this.$loading = false;
          this.customerInfo = res.data.listing.data;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    pageNumber(e) {
      this.page = e;
      this.fetchCustomerList();
    },
  },
};
</script>
<style lang="scss" scoped>
.light-grey {
  color: #e0e0e0;
}
.customer-info {
  cursor: pointer;
}

.theme-light {
  .customer-info a {
    color: $body-color;
  }
}
.theme-dark {
  .light-grey {
    color: #404040;
  }
  .customer-info {
    color: $white-color;
    background-color: #202020 !important;
    a {
      color: $white-color;
    }
    .row {
      border-bottom: 1px solid #404040;
      .badge {
        background: #404040;
        color: $white-color;
      }
    }
  }
  .cash-register-data {
    h5 {
      color: $white-color;
    }
  }
}
.customer-info {
  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .badge {
      font-weight: normal;
      background: $light-grey;
      color: $body-color;
      // width: 13 0px;
      @include text-overflow();
    }
  }
}
.btn-success.disabled,
.btn-success:disabled {
  background: #808080;
  border-color: #808080;
}

.custom-select {
  font-size: 13px;
}
.customer-data {
  height: calc(100vh - 132px);
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -15px;
  margin-right: -15px;
  @include custom-scrollbar();
}
</style>
